import { Placement, Side } from "@floating-ui/react";

export const DEFAULT_PLACEMENT_SIDE: Side = "bottom";
export const DEFAULT_PLACEMENT: Placement = `${DEFAULT_PLACEMENT_SIDE}-start`;
